import { Store } from "../store";

export const colors = {
    white: '#FFFFFF',
    black: '#000000',
    blue: '#00B1D1',
    fluorescentBlue: '#00B1D1',
    alertRed: '#930202',
    lightGrey: '#B5B5B5',
    backgroundGrey: '#F2F2F2',
    placeholderGrey: '#979797',
    orange: '#FFBE4A',
    green: '#57C944',
    red: '#FF4C5D',
    lightBlue: '#00DFE9',
    darkBlue: '#0085B9',
    darkGrey: '#979797',
    lighterGrey: '#EEEEEE'
}

export const pageBackgrounds = {
    loginPage: { background: 'unset', backgroundColor: colors.white },
    registerPage: {
        background:
            'linear-gradient(80deg, rgb(250, 250, 250) 0%, rgb(230, 230, 230) 100%)',
    },
    homePage: {
        background: colors.white
    },
    reimbursementPage:{
        background: colors.white
    },
    forgotPasswordPage: {
        background:
            'linear-gradient(80deg, rgb(250, 250, 250) 0%, rgb(230, 230, 230) 100%)',
    },
}

export default colors;